export const BRAZE_EVENTS = {
  PAYMENT_STARTED: 'Payment Started',
  PAYMENT_COMPLETED: 'Payment Completed',
  PAGE_LOAD: 'Page_Load',
  LOGGED_IN: 'lg_in_st',
  VIEW: 'view',
  APP_LAUNCH: 'app_launch',
} as const;

export const BRAZE_CUSTOM_ATTRIBUTES = {
  APP_NAME: 'app_name',
  APP_PLATFORM: 'app_platform',
  APP_VERSION: 'app_version',
  HIDE_SCORE: 'alrt_hs_web',
  TUNE_IN_FAV: 'alrt_fav_web',
  WEB_PUSH_NOTIFICATION: 'alrt_nfs_web',
};

export const BRAZE_NOTIFICATION_STATE = {
  ENABLED: 'marketing_notifications_enabled',
  DISABLED: 'marketing_notifications_disabled',
};
